//环信appKey默认配置项
// export const DEFAULT_EASEMOB_APPKEY = '1140220211108436#szbobo'
export const DEFAULT_EASEMOB_APPKEY = '1140220211108436#demo'
// export const DEFAULT_EASEMOB_APPKEY = 'easemob#easeim'
export const DEFAULT_EASEMOB_SOCKET_URL = '//im-api-v2.easemob.com/ws'
export const DEFAULT_EASEMOB_REST_URL = '//a1.easemob.com'
